/**封装axios*/
import axios from 'axios';
import store from '@/store'
import NProgress from 'nprogress';
import { baseURL } from "@/utils"
import { MessageBox } from 'element-ui';
import router from '@/router'

const http = {}

var instance = axios.create({
  timeout: 5000
})

instance.defaults.baseURL = baseURL


// 添加请求拦截器
instance.interceptors.request.use(config => {
  NProgress.start();
  // 添加请求头token
  if (store.state.userToken && !config.url.includes('/login')) {
    config.headers.token = store.state.userToken
  }

  return config
}, error => {
  console.log(error)
})

// 响应拦截器即异常处理
instance.interceptors.response.use(response => {
  NProgress.done();

  // if (response.data.status == 401 && response.data.message != '用户名或密码错误') {
  //   MessageBox.alert('您的登录已过期，请重新登录', '提示', {
  //     confirmButtonText: '确定',
  //     callback: action => {
  //       router.replace('/login')
  //     }
  //   });
  // }

  return response.data
}, error => {
  return Promise.reject(error.response)
})

http.get = function (url, options) {
  return new Promise((resolve, reject) => {
    instance.get(url, options).then(response => {
      resolve(response)
    }).catch(error => {
      alert(error)
    })
  })
}

http.post = function (url, data, options) {
  return new Promise((resolve, reject) => {
    instance.post(url, data, options).then(response => {
      resolve(response)
    }).catch(error => {
      reject(error)
      alert(error)
    })
  })
}

http.put = function (url, data) {
  return new Promise((resolve, reject) => {
    instance.put(url, data).then(response => {
      resolve(response)
    }).catch(error => {
      reject(error)
      alert(error)
    })
  })
}

http.delete = function (url, data) {
  return new Promise((resolve, reject) => {
    instance.delete(url, data).then(response => {
      resolve(response)
    }).catch(error => {
      reject(error)
      alert(error)
    })
  })
}

export default http